import DCard from './src';

DCard.install = Vue => {
  Vue.component('DCard', DCard);
};

export default DCard;
